export default __webpack_public_path__ + "static/media/ci-segment-new.d6a4da62.svg";